/** @jsx jsx */

import React, { useRef, useContext } from 'react';
import { css, jsx } from '@emotion/core';
import EditorBtn from 'components/UI/EditorBtn';
import { colors } from 'styles/variables';
import getStore from 'services/getStore';
//
import {
  uploadToD3,
  createUpload,
} from 'services/graphQLFileIO/graphqlCreateUpload';

interface IFileUploader {
  label: string;
  onUploadStart?: any;
  onUploadComplete: (result: { [key: string]: any }, e: any) => void;
  btnColor?: string;
  style?: { [key: string]: any };
}

const store = getStore();
const { lGrey0 } = colors;

const onFileSelected = async (e, onUploadComplete) => {
  e.persist();

  const file = e.target?.files?.[0];

  let signedId;

  try {
    signedId = await uploadToD3()?.upload(file, $ => {
      console.log('progress :', $);
    });
  } catch (err) {
    console.error('ERROR UPLOADING TO D3', err);
  }

  try {
    const { status, data } = await createUpload({
      signedId,
      file,
      type: 'Image',
    } as any);

    const { id, name, url } = data?.file || {};

    onUploadComplete(
      {
        id,
        name,
        url,
      },
      e
    );
    //
  } catch (err) {
    console.error(`ERROR GETTING GRAPHQL UPLOAD DATA`, err);
  }
};

const FileUploader = ({
  label,
  onUploadStart,
  onUploadComplete,
  btnColor = lGrey0,
  style = {},
  ...props
}: IFileUploader) => {
  const fileUpload = useRef<HTMLInputElement>(null);

  return (
    <div>
      <EditorBtn
        label={label}
        css={css`
          padding-left: 30px;
          padding-right: 30px;
          background: ${btnColor};
        `}
        style={style}
        onClick={() => {
          onUploadStart && onUploadStart();
          fileUpload.current!.click();
        }}
        {...props}
      />
      <input
        ref={fileUpload}
        type="file"
        id="file-upload"
        style={{ display: 'none' }}
        onChange={e => {
          onFileSelected(e, onUploadComplete);
        }}
      />
    </div>
  );
};

async function rawUploader(files, onUploadComplete) {
  const { projectId } = store.getState();

  const FileList = {
    0: files[0],
    length: 1,
  };

  try {
    const { status, data } = await createUpload({
      file: FileList[0],
      type: 'Image',
    } as any);

    const { id, name, url } = data?.file || {};

    onUploadComplete({
      id,
      name,
      url,
    });
    //
  } catch (err) {
    console.error(`ERROR GETTING GRAPHQL UPLOAD DATA`, err);
  }
}

export default FileUploader;
export { onFileSelected, rawUploader };
